import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { trackPageView } from '../utils/analytics';
import SEOHead from '../components/SEOHead';

const LegalDisclaimerPage = () => {
  useEffect(() => { trackPageView('/legal-disclaimer', 'Legal Disclaimer'); }, []);

  return (
    <div className="min-h-screen bg-void" data-testid="legal-disclaimer-page">
      <SEOHead
        title="Legal Disclaimer"
        description="Legal disclaimer for Avi Cement Limited website content and product information."
        path="/legal-disclaimer"
        noindex
      />
      <section className="relative py-12 md:py-28 overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-20" />
        <div className="container mx-auto px-4 md:px-8 max-w-4xl relative z-10">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-white text-sm mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="text-coral font-mono text-sm mb-4 block">LEGAL</span>
            <h1 className="font-display text-4xl md:text-5xl font-bold text-white mb-4">Legal Disclaimer</h1>
            <p className="text-gray-500 text-sm font-mono">Last updated: March 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="pb-20 md:pb-32">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl">
          <div className="bg-surface border border-white/5 rounded-2xl p-8 md:p-12 space-y-8 text-gray-300 leading-relaxed">
            <div>
              <h2 className="font-display text-xl font-semibold text-white mb-4">Copyright</h2>
              <p className="text-sm">Avi Cement Limited retains copyright on all the text, graphics, and trademarks displayed on this site. All the text, graphics, and trademarks displayed on this site are owned by Avi Cement Limited and used under license by Avi Cement Limited affiliates.</p>
            </div>

            <div>
              <h2 className="font-display text-xl font-semibold text-white mb-4">Usage Restrictions</h2>
              <p className="text-sm">You may print copies of the information on this site for your personal use and store the files on your computer for personal use. You may not distribute text or graphics to others without the express written consent of Avi Cement Limited and Avi Cement Limited affiliates. Also, you may not, without our permission, copy and distribute this information on any other server, or modify or reuse text or graphics on this or any other system.</p>
            </div>

            <div>
              <h2 className="font-display text-xl font-semibold text-white mb-4">Reproduction</h2>
              <p className="text-sm">No reproduction of any part of the site may be sold or distributed for commercial gain, nor shall it be modified or incorporated in any other work, publication, or site, whether in hard copy or electronic format, including postings to any other site. Avi Cement Limited reserves all other rights.</p>
            </div>

            <div>
              <h2 className="font-display text-xl font-semibold text-white mb-4">Accuracy of Information</h2>
              <p className="text-sm">The information on this site has been included in good faith and is for general purposes only. It should not be relied upon for any specific purpose and no representation or warranty is given as regards its accuracy or completeness.</p>
            </div>

            <div>
              <h2 className="font-display text-xl font-semibold text-white mb-4">Investment Disclaimer</h2>
              <p className="text-sm">No information on this site shall constitute an invitation to invest in Avi Cement Limited or any of its affiliates. Neither Avi Cement Limited and Avi Cement Limited affiliates, nor their or their affiliate's officers, employees, or agents shall be liable for any loss, damage, or expense arising out of any access to or use of this site or any site linked to it, including, without limitation, any loss of profit, indirect, incidental or consequential loss.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalDisclaimerPage;
